require('../proposals/promise-any');
require('../proposals/string-replace-all');

module.exports = require('./4');
